import axios from 'axios'
import React, { useContext } from 'react'
import { toast } from 'react-toastify'
import UserContext from '../../../context/UserContext'

interface IProps {
  SaveCloseModal: () => void
  deleteBotId: any
  fetchAllBots: any
}
const IBotDeleteModal: React.FC<IProps> = ({ SaveCloseModal, deleteBotId, fetchAllBots }) => {
  const { currentUser } = useContext(UserContext)
  const DeleteIBotAssistant = async () => {
    const promise = new Promise((resolve, reject) => {
      console.log('resolved with ', resolve)
      console.log('rejected with ', reject)
    })

    try {
      const formData = new FormData()
      formData.append('bot_id', deleteBotId)
      formData.append('bg_id', currentUser.id)

      const response = await axios
        .post(`${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/bot/delete`, formData, {})
        .then((res) => {
          toast.success(res?.data?.message)
          SaveCloseModal()
          fetchAllBots()
        })
    } catch (error) {
      // Handle errors
      toast.error('Error making the POST request')
      SaveCloseModal()
      console.error('Error making the POST request', error)
    } finally {
    }
    return promise
  }
  return (
    <div>
      <div className='card w-530px h-180px '>
        <div className='d-flex flex-column justify-content-between mx-0 px-0 mb-2'>
          <span className='mb-2 me-auto fw-bold'>
            <p>Are you sure want to delete this iBotAssistant ?</p>
          </span>
          <div className='d-flex justify-content-end'>
            <button type='reset' className='btn btn-sm btn-secondary' onClick={DeleteIBotAssistant}>
              OK.Got it
            </button>
            <button type='reset' className='btn btn-sm btn-danger ms-3' onClick={SaveCloseModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IBotDeleteModal
